import { useSelector } from 'react-redux';
import { selectDeviceType } from '@client/settings/redux/redux';
import { DEVICE_TYPE } from 'b2b-components/utils/device';

export const useDeviceType = (): DEVICE_TYPE => useSelector(selectDeviceType);
